module.exports = __webpack_public_path__ + "img/centered-logo-nav-toyota.493e6836.png";